import { render, staticRenderFns } from "./faqGold.vue?vue&type=template&id=796a46a2"
import script from "./faqGold.vue?vue&type=script&lang=js"
export * from "./faqGold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports